export default __webpack_public_path__ + "static/media/chevron-down.8584c808.svg";